import { render, staticRenderFns } from "./PendingRegistration.vue?vue&type=template&id=f601ea30&scoped=true"
import script from "./PendingRegistration.vue?vue&type=script&lang=js"
export * from "./PendingRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f601ea30",
  null
  
)

export default component.exports